import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { DateFormats, DateTimeFormats, LanguageType, NumberFormats } from '../constants';

dayjs.extend(utc);

const normalizeDate = (date, format) => dayjs(date instanceof dayjs ? date.format(DateFormats.Default) : date).format(format);

const formatters = {
  percentage: { digits: 2, suffix: '%' },
  currency: { digits: 2, prefix: '$' },
  default: { digits: 0 },
  currency_short: { digits: 0, prefix: '$' },
  percentage_short: { digits: 0, suffix: '%' },
  signed_integer: { digits: 0, signDisplay: 'exceptZero' },
};

export const FormatHelper = {
  removeSpecialCharacters: value => value?.replace(/[^0-9a-zA-Z_-]+/g, ''),
  formatDate: (value, format = DateFormats.Default) => normalizeDate(value, format),
  formatDateTime: (value, format = DateTimeFormats.Default) => normalizeDate(value, format),
  format: (value, format = NumberFormats.Default, round = false) => {
    if (format in formatters && isNaN(value)) return 'N/A';
    if (value === undefined) return undefined;
    if (value === null) return 'N/A';

    const { digits, prefix, suffix, ...rest } = formatters[format] ?? {};

    if (!isNaN(value)) {
      const suffixMultiplier = round ? (+value > 999 && +value < 1000000 ? 'K ' : +value >= 1000000 ? 'M ' : '') : '';
      const formattableValue = round ? (+value < 900 ? value : +value > 999 && +value < 1000000 ? +value / 1000 : +value / 1000000) : value;
      return `${prefix ?? ''}${new Intl.NumberFormat('en-US', {
        minimumFractionDigits: digits ?? 2,
        ...rest,
      }).format(parseFloat(isNaN(formattableValue) || !isFinite(formattableValue) ? 0 : formattableValue).toFixed(digits))}${suffixMultiplier}${
        suffix ?? ''
      }`;
    } else if (Date.parse(value)) {
      return FormatHelper.formatDate(value);
    }
    return value;
  },
  formatNumericTime: (milliseconds, language) => {
    const seconds = milliseconds / 1000;
    return language === LanguageType.Arabic
      ? `${Math.floor(seconds / 60)} د ${Math.floor(seconds % 60)} ث`
      : `${Math.floor(seconds / 60)} m ${Math.floor(seconds % 60)} s`;
  },

  currency: (value, t) => (value ? value?.toLocaleString('en-US', { maximumFractionDigits: 1 }) + ` ${t('riyal_symbol')}` : '-'),
};
